<template>
  <div class="parent">
    <div class="inner">
      <amplify-authenticator v-bind:authConfig="authConfig"></amplify-authenticator>
    </div>
  </div>
</template>

<script>
import { components } from "aws-amplify-vue";

export default {
  components: {
    ...components
  },
  props: [],
  data() {
    return {
      authConfig: {
        signInConfig: {
          isSignUpDisplayed: false
        },
        signUpConfig: {
          hideDefaults: true,
          signUpFields: [
            {
              label: "Username",
              key: "username",
              required: true,
              type: "text",
              displayOrder: 0
            },
            {
              label: "Email",
              key: "email",
              required: true,
              type: "email",
              displayOrder: 1
            },
            {
              label: "Password",
              key: "password",
              required: true,
              type: "password",
              displayOrder: 2
            }
          ]
        },
        confirmSignUpConfig: {},
        forgotPasswordConfig: {},
        confirmSignInConfig: {}
      }
    };
  }
};
</script>

<style scoped>
.parent {
  margin-top: 40px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  justify-content: center;
}
</style>
